var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_390_32698",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_390_32698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4587 38.3332C9.55171 38.3332 7.06803 37.3269 5.00762 35.3144C2.9472 33.3019 1.91699 30.8422 1.91699 27.9353C1.91699 25.4436 2.66769 23.2234 4.16908 21.2748C5.67046 19.3262 7.63505 18.0804 10.0628 17.5373C10.8614 14.5984 12.4587 12.2186 14.8545 10.3978C17.2503 8.57692 19.9656 7.6665 23.0003 7.6665C26.7378 7.6665 29.9083 8.96824 32.5118 11.5717C35.1153 14.1752 36.417 17.3457 36.417 21.0832C38.6212 21.3387 40.45 22.2891 41.9035 23.9342C43.3569 25.5794 44.0837 27.504 44.0837 29.7082C44.0837 32.104 43.2451 34.1405 41.568 35.8175C39.891 37.4946 37.8545 38.3332 35.4587 38.3332H24.917C23.8628 38.3332 22.9604 37.9578 22.2097 37.2071C21.459 36.4564 21.0837 35.554 21.0837 34.4998V24.629L18.017 27.5998L15.3337 24.9165L23.0003 17.2498L30.667 24.9165L27.9837 27.5998L24.917 24.629V34.4998H35.4587C36.8003 34.4998 37.9344 34.0366 38.8607 33.1103C39.7871 32.1839 40.2503 31.0498 40.2503 29.7082C40.2503 28.3665 39.7871 27.2325 38.8607 26.3061C37.9344 25.3797 36.8003 24.9165 35.4587 24.9165H32.5837V21.0832C32.5837 18.4318 31.6493 16.1717 29.7805 14.303C27.9118 12.4342 25.6517 11.4998 23.0003 11.4998C20.3489 11.4998 18.0889 12.4342 16.2201 14.303C14.3514 16.1717 13.417 18.4318 13.417 21.0832H12.4587C10.6059 21.0832 9.02463 21.738 7.71491 23.0478C6.40519 24.3575 5.75033 25.9387 5.75033 27.7915C5.75033 29.6443 6.40519 31.2255 7.71491 32.5353C9.02463 33.845 10.6059 34.4998 12.4587 34.4998H17.2503V38.3332H12.4587Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloudUpload.ee32a28c6f5ceed77b7313120fd03a55.svg";
export { ForwardRef as ReactComponent };